<template>
  <NotificationLayout :is-loading="isLoading" :is-template="notifData?.isTemplate" :on-send-now="showSendModal" :on-action="handleSave" :on-settings-action="onSettingsAction" :on-list-action="onListAction" :on-log-action="showLogModal">

    <div class="content-layout">

      <div class="variable-sidebar">
        <div class="sidebar-header">
          <svg class="sidebar-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1C3CD5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="4 7 4 4 20 4 20 7"></polyline>
            <line x1="9" y1="20" x2="15" y2="20"></line>
            <line x1="12" y1="4" x2="12" y2="20"></line>
          </svg>
          <span class="sidebar-title">{{ $t('variables') }}</span>
        </div>

        <select class="category-select" v-model="selectedCategory">
          <option :value="null">{{ $t('all_variables') }}</option>
          <option v-for="(cat, catKey) in notifCategoryMap" :key="catKey" :value="catKey">
            {{ $t(cat.descKey) }}
          </option>
        </select>

        <div class="sidebar-buttons">
          <div
              v-for="variable in filteredVariables"
              :key="variable.key"
              class="variable-btn"
              :class="{ 'copied': copiedVariable === variable.key }"
              @click="copyVariable(variable.key)"
          >
            <div class="variable-btn-top">
              <span class="variable-btn-label">{{ $t(variable.labelKey) }}</span>
              <svg class="copy-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
              </svg>
            </div>
            <span class="variable-btn-key">{{ variable.key }}</span>
            <div class="variable-tooltip">{{ $t(variable.descKey) }}</div>
          </div>
        </div>
      </div>

      <!-- SAĞ: Content %60 -->
      <div class="content-main">
        <div class="tab-panel-wrapper no-text-select">
          <div class="tab-panel-left"></div>
          <div class="tab-panel-right">
            <TranslationDropdown :selected-language="activeLanguage" :on-select="handleLanguageChange"/>
          </div>
        </div>

        <div class="card-wrapper">
          <div class="title-card-border"></div>
          <div class="question-dropdown" v-click-outside="dropdownOutsideClick">
            <div class="dropdown-button" :class="{'active': typeDropdownVisible}" @click="typeDropdownVisible = !typeDropdownVisible">
              <img :src="notifTypes.find(type => type.id === notifData.content?.type).icon" />
              <span>{{notifTypes.find(type => type.id === notifData.content?.type).name}}</span>
              <img src="@/assets/images/arrowdown.svg" class="arrow" />
            </div>

            <div class="dropdown-items" v-if="typeDropdownVisible">
              <template v-for="nType in notifTypes">
                <div class="dropdown-item" v-if="!nType.requireJourney || journeyId" @click="() => selectType(nType.id)">
                  <img :src="nType.icon" />
                  <span>{{nType.name}}</span>
                </div>
              </template>
            </div>
          </div>

          <input class="title-input mt-3 w-100" :placeholder="this.$t('add_your_label_here')" v-model="notifData.content.label"/>
          <input class="description-input" :placeholder="this.$t('info_of_the_notification')"  v-model="notifData.content.info" />
        </div>

        <Transition name="slide-up">
          <div class="card-wrapper mt-3" v-if="notifData.content?.type === 'video'">
            <div class="upload-row">
              <FileDrop type="mp4" :on-file-selected="handleFile" :attach="notifData.content?.file?.attach" :selected-file="notifData.content?.file?.file?.attachUrl" :file-info="notifData.content?.file?.file?.info" :not-binary="true" :on-delete="() => handleVideoDelete(notifData.content.file)" />
              <FileDrop :on-file-selected="handleCoverFile" :attach="notifData.content?.coverImage?.attach" :selected-file="notifData.content?.coverImage?.file?.attachUrl" :file-info="notifData.content?.coverImage?.file?.info" :not-binary="true" :on-delete="() => handleDelete(notifData.content.coverImage)"/>
            </div>
          </div>
        </Transition>

        <Transition name="slide-up">
          <div class="card-wrapper mt-3" v-if="notifData.content?.type === 'audio'">
            <div class="upload-row">
              <FileDrop type="mp3" :on-file-selected="handleFile" :attach="notifData.content?.file?.attach" :selected-file="notifData.content?.file?.file?.attachUrl" :file-info="notifData.content?.file?.file?.info" :not-binary="true" :on-delete="() => handleVideoDelete(notifData.content.file)"/>
              <FileDrop :on-file-selected="handleCoverFile" :attach="notifData.content?.coverImage?.attach" :selected-file="notifData.content?.coverImage?.file?.attachUrl" :file-info="notifData.content?.coverImage?.file?.info" :not-binary="true" :on-delete="() => handleDelete(notifData.content.coverImage)" />
            </div>
          </div>
        </Transition>
        <Transition name="slide-up">
          <div class="card-wrapper mt-3" v-if="notifData.content?.type === 'blog'">
            <span class="form-label">{{$t('select_a_blog')}}</span>
            <SelectBox class="select-box"
                       :full-width="true"
                       :options="blogList"
                       :on-select="handleBlogSelect"
                       :placeholder="this.$t('select_a_blog')"
                       :selected-value="notifData.content.blogId ? notifData.content.blogId :  ''" />
          </div>
        </Transition>

        <Transition name="slide-up">
          <div class="card-wrapper mt-3" v-if="notifData.content?.type === 'documentDownload'">
            <FileDrop type="allFiles" :on-file-selected="handleFile" :attach="notifData.content?.file?.attach" :file-info="notifData.content?.file?.info" :selected-file="notifData.content.file?.attachUrl" :on-delete="() => handleDelete(notifData.content)" :not-binary="true"  />
          </div>
        </Transition>

        <Transition name="slide-up">
          <div class="card-wrapper mt-3" v-if="notifData.content?.type === 'documentUpload'">
            <div class="upload-option" v-for="option in notifData.content?.options">
              <div class="form-row-textarea">
                <textarea class="form-input mt-3" style="width: 100%" :placeholder="this.$t('label')" v-model="option.label"  v-textarea-autoresize></textarea>
                <textarea class="form-input mt-3" style="width: 100%" :placeholder="this.$t('info')" v-model="option.info"  v-textarea-autoresize></textarea>
              </div>

              <div class="form-row mt-3">
                <multiselect
                    v-model="option.accepted"
                    :options="filteredUploadTypes"
                    track-by="id"
                    label="name"
                    :multiple="true"
                    placeholder="Accepted types"
                    :internal-search="false"
                    @search-change="onUploadTypeSearch"
                >
                  <template #noOptions>
                    <span class="no-data-found">{{$t('no_data_found')}}</span>
                  </template>
                </multiselect>

                <SelectBox :options="testOptions" :on-select="(value) => handleTestSelect(option, value)" :selected-value="option.testId ? option.testId : ''" :placeholder="this.$t('select_a_test')" />
              </div>

              <div class="form-row mt-3 mb-3">
                <div class="form-row">
                  <span class="form-label">{{$t('required')}}</span>
                  <Switch v-model="option.required" />
                </div>
                <div class="form-row">
                  <span class="form-label">{{$t('max_file_size')}}</span>
                  <input type="number" class="form-input-sm" :placeholder="this.$t('max_file_size')" v-model="option.max_file_size"/>
                </div>
                <div class="row-end">
                  <img src="@/assets/images/trash.svg" @click="deleteUpload(option)" />
                </div>
              </div>

            </div>

            <div class="card-footer mt-3">
              <button class="primary-button" @click="addUploadOption">{{$t('add')}}</button>
            </div>
          </div>
        </Transition>

        <Transition name="slide-up">
          <div class="card-wrapper mt-3" v-if="notifData.content?.type === 'interview'">
            <input type="datetime-local" class="form-input" v-model="notifData.content.interviewDate" :min="minDateTime" />
          </div>
        </Transition>

        <Transition name="slide-up">
          <div class="card-wrapper mt-3" v-if="notifData.content?.type === 'offer'">
            <span class="form-label">{{$t('select_position')}}</span>
            <SelectBox
                class="select-box"
                :options="positionList"
                :on-select="handlePositionSelect"
                :placeholder="this.$t('select_position')"
                :selected-value="notifData.config.openPositionId ? notifData.config.openPositionId : ''"
            />
          </div>
        </Transition>

        <div class="card-wrapper mt-3">
          <div class="type-title">
            <span class="type-title-txt">{{$t('in_app')}}</span>
            <Switch v-model="inApp" :on-toggle="handleInAppToggle" />
          </div>
          <Transition name="slide-up">
            <div v-if="inApp">
              <textarea class="form-input mt-3 mb-3" style="width: 100%" :placeholder="this.$t('subject')" v-model="notifData.push.subject" v-textarea-autoresize></textarea>
              <quill-editor theme="snow" content-type="html" v-model:content="notifData.push.content"></quill-editor>
            </div>
          </Transition>
        </div>

        <div class="card-wrapper mt-3">
          <div class="type-title">
            <span class="type-title-txt">{{$t('e-mail')}}</span>
            <Switch v-model="email" :on-toggle="handleMailToggle" />
          </div>
          <Transition name="slide-up">
            <div v-if="email">
              <textarea class="form-input mt-3 mb-3" style="width: 100%" :placeholder="this.$t('subject')" v-model="notifData.mail.subject" v-textarea-autoresize></textarea>
              <quill-editor theme="snow" content-type="html" v-model:content="notifData.mail.content"></quill-editor>
            </div>
          </Transition>
        </div>

        <div class="card-wrapper mt-3">
          <div class="type-title">
            <span class="type-title-txt">{{$t('sms')}}</span>
            <Switch v-model="sms" :on-toggle="handleSMSToggle"/>
          </div>
          <Transition name="slide-up">
            <div v-if="sms">
              <textarea class="form-input mt-3" style="width: 100%" :placeholder="this.$t('subject')" v-model="notifData.sms.subject"  v-textarea-autoresize></textarea>
              <textarea class="form-input mt-3" style="width: 100%" :placeholder="this.$t('content')" v-model="notifData.sms.content"  v-textarea-autoresize></textarea>
            </div>
          </Transition>
        </div>
      </div>

    </div>

    <NotificationTemplateSettingsModal
        :visible="isSettingsModalVisible"
        :on-hide="closeSettingsModal"
        :settings="notifData.config"
    />
    <NotificationListModal
        :visible="isListModalVisible"
        :on-hide="closeListModal"
        :list="userList"
    />
    <SendNotificationModal :visible="sendModalVisible" :onHide="handleSendModalHide" :journey-id="journeyId" :notif-data="notifData" />
    <LoadingOverlay :is-loading="isLoading" />
    <LogModal
        :visible="isLogModalVisible"
        :on-hide="hideLogModal"
        :data="logData"
    />
  </NotificationLayout>
</template>

<script>

import LoadingOverlay from "@/components/LoadingOverlay.vue";
import NotificationLayout from "@/components/layouts/NotificationLayout.vue";
import notificationContentService from "@/service/notificationContentService";
import SendNotificationModal from "@/components/modals/SendNotificationModal.vue";
import {deepClone, formatDateDMYHI, handleErrorResponse} from "@/utils/utils";
import Switch from "@/components/Switch.vue";
import videoOutline from "@/assets/images/videoOutline.svg";
import audioOutline from "@/assets/images/audioOutline.svg";
import textOutline from "@/assets/images/textOutline.svg";
import downloadOutline from "@/assets/images/downloadOutline.svg";
import uploadOutline from "@/assets/images/uploadOutline.svg";
import blogOutline from "@/assets/images/blogOutline.svg";
import linkOutline from "@/assets/images/linkOutline.svg";
import notificationsOutline from "@/assets/images/notificationOutline.svg";
import camOutline from "@/assets/images/camOutline.svg";
import FileDrop from "@/components/FileDrop.vue";
import Multiselect from "vue-multiselect";
import blogService from "@/service/blogService";
import SelectBox from "@/components/SelectBox.vue";
import testService from "@/service/testService";
import NotificationTemplateSettingsModal from "@/components/modals/NotificationTemplateSettingsModal.vue";
import NotificationListModal from "@/components/modals/NotificationListModal.vue";
import TranslationDropdown from "@/components/TranslationDropdown.vue";
import openPositionsService from "../service/openPositionsService";
import LogModal from "@/components/modals/LogModal.vue";
import fileService from "@/service/fileService";

export default {
  name: 'NotificationDetails',
  components: {
    LogModal,
    TranslationDropdown,
    NotificationListModal,
    NotificationTemplateSettingsModal,
    SelectBox,
    Multiselect,
    FileDrop,
    Switch,
    SendNotificationModal,
    NotificationLayout,
    LoadingOverlay,
  },
  data() {
    return {
      copiedVariable: null,
      allVariables: [
        { key: ':user_name',     labelKey: 'var_user_name',     descKey: 'var_desc_user_name' },
        { key: ':user_surname',  labelKey: 'var_user_surname',  descKey: 'var_desc_user_surname' },
        { key: ':user_nickname', labelKey: 'var_user_nickname', descKey: 'var_desc_user_nickname' },
        { key: ':expert_name',   labelKey: 'var_expert_name',   descKey: 'var_desc_expert_name' },
        { key: ':session_date',  labelKey: 'var_session_date',  descKey: 'var_desc_session_date' },
        { key: ':session_time',  labelKey: 'var_session_time',  descKey: 'var_desc_session_time' },
        { key: ':invite_link',   labelKey: 'var_invite_link',   descKey: 'var_desc_invite_link' },
        { key: ':file_name',     labelKey: 'var_file_name',     descKey: 'var_desc_file_name' },
        { key: ':file_id',       labelKey: 'var_file_id',       descKey: 'var_desc_file_id' },
        { key: ':journey_id',    labelKey: 'var_journey_id',    descKey: 'var_desc_journey_id' },
      ],
      notifCategoryMap: {
        booked_user:                        { descKey: 'cat_booked_user',                        keys: [':user_name', ':user_surname', ':user_nickname', ':session_date', ':expert_name'] },
        booked_expert:                      { descKey: 'cat_booked_expert',                      keys: [':user_name', ':user_surname', ':user_nickname', ':session_date'] },
        expert_reservation_pending_expert:  { descKey: 'cat_expert_reservation_pending_expert',  keys: [':user_name', ':expert_name', ':session_date', ':session_time'] },
        expert_reservation_accepted:        { descKey: 'cat_expert_reservation_accepted',        keys: [':user_name', ':expert_name', ':session_date', ':session_time'] },
        expert_reservation_planned:         { descKey: 'cat_expert_reservation_planned',         keys: [':user_name', ':expert_name', ':session_date', ':session_time'] },
        expert_reservation_completed:       { descKey: 'cat_expert_reservation_completed',       keys: [':user_name', ':expert_name', ':session_date', ':session_time'] },
        expert_reservation_cancelled_user:  { descKey: 'cat_expert_reservation_cancelled_user',  keys: [':user_name', ':expert_name', ':session_date', ':session_time'] },
        expert_reservation_cancelled_expert:{ descKey: 'cat_expert_reservation_cancelled_expert', keys: [':user_name', ':expert_name', ':session_date', ':session_time'] },
        invite_user:                        { descKey: 'cat_invite_user',                        keys: [':user_name', ':user_surname', ':invite_link'] },
        file_approved:                      { descKey: 'cat_file_approved',                      keys: [':file_name', ':file_id', ':journey_id'] },
        file_rejected:                      { descKey: 'cat_file_rejected',                      keys: [':user_name'] },
        test_assign_user:                   { descKey: 'cat_test_assign_user',                   keys: [':user_name'] },
      },
      selectedCategory: null,
      deleteList:[],
      logData:[],
      isLogModalVisible:false,
      isLoading: true,
      activeLanguage: 'tr',
      sendNowLoading: false,
      sendModalVisible: false,
      typeDropdownVisible: false,
      editMode: false,
      journeyId: null,
      uploadTypeSearchQuery: '',
      uploadTypes: [
        {
          id: 'png',
          name: 'PNG'
        },
        {
          id: 'jpg',
          name: 'JPG'
        },
        {
          id: 'pdf',
          name: 'PDF'
        },
      ],
      notifTypes: [
        {
          id: 'video',
          name: this.$t('video_type'),
          icon: videoOutline,
          requireJourney: false,
        },
        {
          id: 'audio',
          name: this.$t('audio_type'),
          icon: audioOutline,
          requireJourney: false,
        },
        {
          id: 'text',
          name: this.$t('text_question'),
          icon: textOutline,
          requireJourney: false,
        },
        {
          id: 'documentDownload',
          name: this.$t('document_download'),
          icon: downloadOutline,
          requireJourney: false,
        },
        {
          id: 'documentUpload',
          name: this.$t('document_upload'),
          icon: uploadOutline,
          requireJourney: false,
        },
        {
          id: 'blog',
          name: this.$t('blog_title'),
          icon: blogOutline,
          requireJourney: false,
        },
        {
          id: 'link',
          name: 'Link',
          icon: linkOutline,
          requireJourney: false,
        },
        {
          id: 'offer',
          name: this.$t('send_offer'),
          icon: notificationsOutline,
          requireJourney: false,
        },
        {
          id: 'interview',
          name: 'Interview',
          icon: camOutline,
          requireJourney: true,
        }
      ],
      notifData: {
        sendDate: null,
        status: true,
        users: [],
        content: {
          coverImage:{
            file:{
              attachUrl:null
            }
          },
          file:{
            attach:null
          },
          type: 'text',
          label: '',
          info: '',
        },
        sms: {},
        push: {},
        mail: {},
        config: {
          delay: {
            type: 'day',
            value: '',
          },
          pending: {
            title: '',
            description: '',
          },
          waitFor: false,
        },
      },
      inApp: true,
      email: false,
      sms: false,
      blogList: [],
      positionList: [],
      testList: [],
      testOptions: [],
      isSettingsModalVisible: false,
      isListModalVisible:false,
      userList:[],
    }
  },

  async mounted() {
    const routeParams = this.$route.params;
    const routeQuery = this.$route.query;

    if (routeQuery.journeyId && routeQuery.journeyId !== '' && routeQuery.journeyId !== 'null') {
      this.journeyId = routeQuery.journeyId;
    }

    await blogService.getBlogList()
        .then(response => {
          this.blogList = response.data.data.map(blog => {
            return {
              value: blog.blogId,
              text: blog.name,
            }
          });
        })
        .catch(err => {
          handleErrorResponse(err, this.$snackbar);
        });

    await testService.getTestList({ types: [2] }).then((response) => {
      this.testList = response.data.data;
    }).catch(() => {
      this.$snackbar.add({
        text: this.$t('fetching_test_list_failed'),
        type: "error",
      });
    });

    await openPositionsService.getPositionsList()
        .then(response => {
          this.positionList = response.data.data.map(position => {
            return {
              value: position.positionId,
              text: position.title,
            }
          });
        })
        .catch(err => {
          handleErrorResponse(err, this.$snackbar);
        });


    if (routeParams.id !== "new") {
      this.handleGetDetail();
    } else {
      this.isLoading = false;
    }

    this.getLogs(this.$i18n.locale)

  },
  watch: {
    testList: {
      handler: function (val) {
        this.testOptions = val.filter(item => item.type === 'test').map(test => {
          return {
            value: test.id,
            text: test.name,
          }
        });
      },
      deep: true,
    }
  },
  methods: {
    copyVariable(key) {
      navigator.clipboard.writeText(key);
      this.copiedVariable = key;
      setTimeout(() => {
        this.copiedVariable = null;
      }, 1500);
    },
    onUploadTypeSearch(query) {
      this.uploadTypeSearchQuery = query;
    },
    handleVideoDelete(element) {
      this.deleteList.push(element.file.fillableId);
      element.attach = null;
      element.file.attachUrl = null;
      this.notifData.content.file.attach=null;
    },
    handleDelete(element) {
      this.deleteList.push(element.file.fillableId);
      element.file.attach = null;
      element.file.attachUrl = null;
    },

    getLogs(lang){
      const routeParams = this.$route.params;
      if(routeParams.id!=='new'){
        notificationContentService.getDetailLogs(lang,routeParams.id).then((res) => {
          this.logData=res.data.data;
        })
      }

    },
    showLogModal(){
      this.isLogModalVisible=true;
    },
    hideLogModal(){
      this.isLogModalVisible=false;
    },
    handleGetDetail() {
      const routeParams = this.$route.params;

      this.isLoading = true;

      notificationContentService.getNotificationDetails(routeParams.id, this.activeLanguage)
          .then(response => {
            this.handleGet(response.data.data);
            this.userList = response.data.data.userList;

          })
          .catch(err => {
            handleErrorResponse(err, this.$snackbar);
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    handleSendModalHide() {
      this.sendModalVisible = false;
    },
    showSendModal() {
      this.sendModalVisible = true;
    },
    dropdownOutsideClick() {
      this.typeDropdownVisible = false;
    },
    selectType: function (typeID) {
      this.typeDropdownVisible = false;
      if (typeID === 'documentUpload') {
        if (!this.notifData.content.options) {
          this.notifData.content.options = [];
        }
        this.notifData.content.options.push({
          label: '',
          info: '',
          accepted: [],
          required: true,
          max_file_size: 5242880,
        });
      } else if (typeID === 'video' && typeID === 'audio') {
        this.notifData.content.file = {
          attach: null,
        };
        this.notifData.content.coverImage = {
          attach: null,
        };

      } else {
        this.notifData.content.options = [];
      }

      this.notifData.content.type = typeID;

    },
    handleGet(data) {
      const tempData = JSON.parse(JSON.stringify(data));

      this.editMode = true;
      this.inApp = tempData.push !== "";
      this.email = tempData.email !== "";
      this.sms = tempData.sms !== "";

      if (tempData.content?.type === 'documentUpload') {
        try {
          tempData.content.options.map(option => {
            if (!option.accepted) {
              option.accepted = [];
            } else {
              option.accepted = option.accepted.split(',').map(type => {
                return {
                  id: type,
                  name: type.toUpperCase(),
                }
              });
            }

          });
        } catch (e) {
          console.log(e);
        }
      }

      console.log("data", tempData);

      this.notifData = tempData;
    },
    handleFile(file) {
        this.notifData.content.file = {};


      this.notifData.content.file.attach = file;
      console.log("file",  this.notifData.content.file.attach);
    },
    handleCoverFile(file) {
      if (!this.notifData.content.coverImage) {
        this.notifData.content.coverImage = {};
      }

      this.notifData.content.coverImage.attach = file;
    },
    handleInAppToggle(status) {
      if (!status) {
        this.notifData.push = {};
      } else {
        this.notifData.push = {
          subject: '',
          content: '',
        }
      }
    },
    handleMailToggle(status) {
      if (!status) {
        this.notifData.mail = {};
      } else {
        this.notifData.mail = {
          subject: '',
          content: '',
        }
      }
    },
    handleSMSToggle(status) {
      if (!status) {
        this.notifData.sms = {};
      } else {
        this.notifData.sms = {
          subject: '',
          content: '',
        }
      }
    },
    addUploadOption() {
      if (!this.notifData.content.options) {
        this.notifData.content.options = [];
      }
      this.notifData.content.options.push({
        label: '',
        info: '',
        accepted: [],
        required: true,
        max_file_size: 5242880,
      });
    },
    handleBlogSelect(blogId) {
      this.notifData.content.blogId = blogId;
    },
    handlePositionSelect(positionId) {
      this.notifData.config.openPositionId = positionId;
    },
    handleSave() {
      const saveTemp = deepClone(this.notifData);
      saveTemp.journeyId = this.journeyId;


      let allFalse = this.uploadStatus.every(status => {
        return Object.values(status)[0] === false;
      });
      if(allFalse){
      if (saveTemp.content.interviewDate && saveTemp.content.interviewDate !== '') {
        try {
          saveTemp.content.interviewDate = formatDateDMYHI(saveTemp.content.interviewDate);
        } catch (e) {
          this.$snackbar.add({
            text: this.$t('invalid_date_format'),
            type: 'error'
          });
          return;
        }
      }

      if (saveTemp.content.type === 'documentUpload') {
        saveTemp.content.options.map(option => {
          option.accepted = option.accepted.map(type => type.id).join(',');
        });
      }

      if (this.editMode) {
        this.updateContent(saveTemp);
      } else {
        this.addContent(saveTemp);
      }
      for(let id of this.deleteList){
        if(id!==undefined && id!==null){
        fileService.deleteFile(id);
        }
      }
      this.deleteList=[];
      }else{
        this.$snackbar.add({
          text: this.$t('wait_for_files_to_be_uploaded'),
          type: "error",
        });
      }
    },
    updateContent(saveTemp) {
      saveTemp.isTemplate = true;
      this.isLoading = true;
      notificationContentService.updateNotificationContent(saveTemp, this.activeLanguage)
          .then(response => {
            this.$snackbar.add({
              text: this.$t('notification_updated'),
              type: 'success'
            });
            this.handleGet(response.data.data);
          })
          .catch(err => {
            handleErrorResponse(err, this.$snackbar);
          })
          .finally(() => {
            this.isLoading = false;
          })
    },
    addContent(saveTemp) {
      saveTemp.isTemplate = true;
      this.isLoading = true;
      notificationContentService.addNotificationContent(saveTemp, this.activeLanguage)
          .then(res => {
            this.$snackbar.add({
              text: this.$t('notification_added'),
              type: 'success'
            });
            window.location.href = "/notification/" + res.data.data.notificationId;
          })
          .catch(err => {
            handleErrorResponse(err, this.$snackbar);
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    deleteUpload(option) {
      if (this.notifData.content.options) {
        if (this.notifData.content.options.length === 1) {
          this.$snackbar.add({
            text: this.$t('at_least_one_upload_option_is_required'),
            type: 'warning'
          });
          return;
        }
        this.notifData.content.options = this.notifData.content.options.filter(opt => opt !== option);
      }
    },
    handleTestSelect(option, testId) {
      option.testId = testId;
    },
    onSettingsAction() {
      this.isSettingsModalVisible = true;
    },
    onListAction() {
      this.isListModalVisible = true;
    },
    closeSettingsModal() {
      this.isSettingsModalVisible = false;
    },
    closeListModal(){
      this.isListModalVisible=false;
    },
    handleLanguageChange(lang) {
      const routeParams = this.$route.params;
      this.activeLanguage = lang;

      if (routeParams.id !== "new") {
        this.handleGetDetail();
      }
    }
  },
  computed: {
    filteredVariables() {
      if (!this.selectedCategory) {
        return this.allVariables;
      }
      const category = this.notifCategoryMap[this.selectedCategory];
      if (!category) return this.allVariables;
      return this.allVariables.filter(v => category.keys.includes(v.key));
    },
    minDateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    },
    filteredUploadTypes() {
      if (!this.uploadTypeSearchQuery) {
        return this.uploadTypes;
      }
      const query = this.uploadTypeSearchQuery.toLocaleLowerCase('tr');
      return this.uploadTypes.filter(type =>
        type.name.toLocaleLowerCase('tr').includes(query)
      );
    }
  }
}
</script>

<style scoped>
.content-layout {
  display: flex;
  flex-direction: row;
  gap: 20px;
  width: 100%;
}

.content-main {
  flex: 8;
  min-width: 0;
}

.variable-sidebar {
  flex: 2;
  min-width: 180px;
  max-width: 220px;
  position: sticky;
  top: 140px;
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  background-color: #FFFFFF;
  border: 1px solid #EAECF0;
  border-radius: 14px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06), 0 1px 2px rgba(16, 24, 40, 0.03);
  align-self: flex-start;
}

.variable-sidebar::-webkit-scrollbar {
  width: 4px;
}

.variable-sidebar::-webkit-scrollbar-track {
  background: transparent;
}

.variable-sidebar::-webkit-scrollbar-thumb {
  background-color: #D0D5DD;
  border-radius: 4px;
}

.sidebar-header {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-bottom: 10px;
  border-bottom: 1px solid #EAECF0;
}

.sidebar-icon {
  flex-shrink: 0;
}

.sidebar-title {
  font-family: euclid_medium, sans-serif;
  font-size: 13px;
  color: #344054;
  letter-spacing: -0.01em;
}

.category-select {
  width: 100%;
  padding: 7px 10px;
  border: 1px solid #f5f5f5;
  border-radius: 8px;
  font-family: euclid_medium, sans-serif;
  font-size: 11px;
  color: #344054;
  background-color: #f5f5f5;
  outline: none;
  cursor: pointer;
  transition: border-color 0.15s ease;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2398A2B3' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  padding-right: 26px;
}

.sidebar-buttons {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.variable-btn {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
  background-color: transparent;
  border: 1px solid transparent;
}

.variable-btn:hover {
  background-color: #F5F8FF;
  border-color: #E0E7FF;
}

.variable-btn:hover .copy-icon {
  opacity: 1;
  color: #1C3CD5;
}

.variable-btn:active {
  background-color: #EEF4FF;
  transform: scale(0.98);
}

.variable-btn.copied {
  background-color: #ECFDF3;
  border-color: #A6F4C5;
}

.variable-btn.copied .variable-btn-label {
  color: #039855;
}

.variable-btn.copied .variable-btn-key {
  color: #039855;
  background-color: #D1FADF;
}

.variable-btn.copied .copy-icon {
  opacity: 1;
  color: #039855;
}

.variable-btn-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.variable-btn-label {
  font-family: euclid_medium, sans-serif;
  font-size: 12px;
  color: #344054;
  transition: color 0.15s ease;
}

.copy-icon {
  opacity: 0;
  color: #98A2B3;
  transition: all 0.15s ease;
  flex-shrink: 0;
}

.variable-btn-key {
  font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
  font-size: 10px;
  color: #1C3CD5;
  background-color: #F2F4F7;
  padding: 2px 6px;
  border-radius: 4px;
  display: inline-block;
  transition: all 0.15s ease;
}

/* Tooltip */
.variable-tooltip {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background-color: #101828;
  color: #FFFFFF;
  font-family: euclid_medium, sans-serif;
  font-size: 11px;
  padding: 6px 10px;
  border-radius: 6px;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.15s ease;
  z-index: 100;
}

.variable-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #101828;
}

.variable-btn:hover .variable-tooltip {
  opacity: 1;
}

@media (max-width: 768px) {
  .content-layout {
    flex-direction: column;
    gap: 16px;
  }

  .variable-sidebar {
    position: static;
    max-height: none;
    align-self: stretch;
  }

  .sidebar-buttons {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 6px;
  }

  .variable-btn {
    flex-direction: row;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    background-color: #F9FAFB;
    border: 1px solid #EAECF0;
    border-radius: 20px;
    flex-shrink: 0;
  }

  .variable-btn-top {
    width: auto;
  }

  .variable-btn-label {
    font-size: 11px;
  }

  .variable-btn-key {
    font-size: 9px;
  }

  .copy-icon {
    display: none;
  }

  .variable-tooltip {
    display: none;
  }
}

.card-wrapper {
  position: relative;
  background-color: #FFFFFF;
  border: 1px solid #EAECF0;
  border-radius: 16px;
  padding: 20px 20px 20px 28px;
  display: flex;
  flex-direction: column;
}

.title-card-border {
  position: absolute;
  height: 100%;
  width: 8px;
  top: 0;
  left: 0;
  background-color: #1C3CD5;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}

.title-input {
  border: none;
  outline: none;
  font-family: euclid_medium, sans-serif;
  font-size: 24px;
  background-color: transparent;
  color: #040C2D;
  margin-bottom: 15px;
}

.description-input {
  border: none;
  outline: none;
  font-family: euclid_medium, sans-serif;
  font-size: 16px;
  background-color: transparent;
  color: #98A2B3;
}

.title-input:focus, .description-input:focus {
  border-bottom: 1px solid #D0D5DD;
}


.question-dropdown {
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 5px;
}

.question-dropdown img {
  height: 16px;
  width: 16px;
}

.question-dropdown span {
  font-family: euclid_medium, sans-serif;
  color: #667085;
  font-size: 12px;
}

.dropdown-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  padding: 5px;
  border-radius: 8px;
}

.dropdown-button:hover, .dropdown-button.active {
  background-color: #F2F4F7;
}

.dropdown-button .arrow {
  transition: transform 0.1s linear;
}

.dropdown-button.active .arrow {
  transform: rotate(180deg);
}

.dropdown-items {
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  background-color: #FFFFFF;
  border: 1px solid #EAECF0;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  z-index: 99;
}

.dropdown-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  padding: 5px;
  border-radius: 8px;
}

.dropdown-item:hover {
  background-color: #F5F7FA;
}

.type-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 7px;
}

.type-title-txt {
  font-family: euclid_medium, sans-serif;
  font-size: 14px;
  color: #040C2D;
}

.upload-row {
  display: flex;
  flex-direction: row;
  gap: 20px;
}

.upload-option {
  border-bottom: 1px solid rgba(102, 112, 133, 0.2);
}

.upload-option:last-child {
  border-bottom: none;
}

.form-row-textarea{
  display: flex;
  flex-direction: column;
}

.card-footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.form-row {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}

.form-row-textarea{
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}

.row-end {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.tab-panel-wrapper {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.tab-panel-left {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.tab-panel-right {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
</style>
